/** YouTube video IDはURL-safeな11文字。 */
export function isValidYoutubeVideoId(value: string): boolean {
  return /^[A-Za-z0-9_-]{11}$/.test(value);
}
